<template>
  <gs-card class="gs-analytics-error">
    <h2 class="gs-analytics-error__title">Analytics could not be loaded</h2>
    <p class="gs-analytics-error__copy">{{ message }}</p>
    <gs-button variant="outline" @click="$emit('retry')">Try again</gs-button>
  </gs-card>
</template>

<script>
export default {
  name: 'AnalyticsErrorCard',
  props: {
    message: {
      type: String,
      default: 'The report did not come back this time. Check your connection and try again.',
    },
  },
};
</script>

<style scoped>
.gs-analytics-error {
  padding: 32px 28px;
  text-align: center;
}

.gs-analytics-error__title {
  margin: 0 0 6px;
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
}

.gs-analytics-error__copy {
  margin: 0 0 16px;
  color: var(--gs-muted-foreground);
  font-size: 14px;
}
</style>
